"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fission = require("@/api/activity/fission");
var _elementUi = require("element-ui");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FissionStatisticsPane',
  components: {},
  props: {
    activityName: {
      type: String,
      required: true
    },
    activityId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      searchForm: {
        activityId: this.activityId,
        initiatorId: '',
        mobile: '',
        limit: 10,
        page: 1,
        status: ''
      },
      listLoading: false,
      total: 0,
      tableData: [],
      initiatorTableKey: 0,
      // 发起者表格的key
      helperTableKey: 0,
      // 助力者表格的key
      dialogVisible: false,
      // 助力明细对话框
      currHelpers: [] // 助力者数据
    };
  },
  created: function created() {
    this.handleSearch();
  },
  methods: {
    handleExport: function handleExport() {
      var _this = this;
      // 导出
      (0, _fission.exportFissionActivity)(this.searchForm).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '裂变活动' + _this.activityName + '统计.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      });
    },
    handleResendInitiator: function handleResendInitiator(row) {
      var _this2 = this;
      // 补发发起者
      var initiatorIdd = row.initiatorIdd;
      (0, _fission.queryFissionActivityResendInitiator)(initiatorIdd).then(function () {
        _this2.$message.success('补发成功');
      });
    },
    handleResendHelper: function handleResendHelper(row) {
      var _this3 = this;
      // 补发助力者
      var helperIdd = row.helperIdd;
      (0, _fission.queryFissionActivityResendHelper)(helperIdd).then(function () {
        _this3.$message.success('补发成功');
      });
    },
    handleHelperDetail: function handleHelperDetail(row) {
      // 助力明细
      this.currHelpers = row.helpers || [];
      this.dialogVisible = true; // 显示助力明细对话框
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getFissionStatisticsPage();
    },
    handleReset: function handleReset() {
      this.searchForm.initiatorId = '';
      this.searchForm.mobile = '';
      this.searchForm.page = 1;
      this.searchForm.limit = 10;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getFissionStatisticsPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getFissionStatisticsPage();
    },
    getFissionStatisticsPage: function getFissionStatisticsPage() {
      var _this4 = this;
      this.listLoading = true;
      (0, _fission.queryFissionStatisticsPage)(this.searchForm).then(function (response) {
        var data = response.data;
        if (data) {
          _this4.tableData = data.records;
          _this4.total = data.total;
        }
        _this4.listLoading = false;
      }, function () {
        _this4.listLoading = false;
      });
    }
  }
};